import { render } from "./CommentUserProfile.vue?vue&type=template&id=42d695f8"
import script from "./CommentUserProfile.vue?vue&type=script&lang=js"
export * from "./CommentUserProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__